import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Select from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import AsyncSelect from 'react-select/lib/Async';
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import { emphasize } from '@material-ui/core/styles/colorManipulator';

import './styles.css'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    fontSize: 16,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      label={props.selectProps.label}
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          ref: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      InputLabelProps={{
        shrink: true,
      }}
      helperText={props.selectProps.helperText}
    />
  );
}

// function Menu2(props) {
//   console.log('props', props);
//   return (<Menu
//     style={{ backgroundColor: 'red' }}
//     {...props.innerProps}
//   >
//     {props.children}
//   </Menu>)
// }

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={event => {
        props.removeProps.onClick();
        props.removeProps.onMouseDown(event);
      }}
    />
  );
}

const components = {
  // Menu: Menu2,
  Option,
  Control,
  NoOptionsMessage,
  Placeholder,
  SingleValue,
  MultiValue,
  ValueContainer,
};

class IntegrationReactSelect extends React.Component {
  render() {
    const { options, classes, loadOptions, placeholder, isMulti, value, onChange, allowCreate, label, helperText, id, onCreateOption } = this.props;

    const params = {
      label,
      helperText,
      classes,
      components,
      value,
      onChange,
      placeholder,
      isMulti,
      cacheOptions: true,
      defaultOptions: true,
      options,
      loadOptions,
      onCreateOption,
    }
    return (
      <div className={classes.root}>
        <NoSsr>
          { loadOptions ?
            (allowCreate ? <AsyncCreatableSelect id={id} {...params} allowCreateWhileLoading /> :
              <AsyncSelect id={id} {...params} />) :
            (allowCreate ? <CreatableSelect id={id} {...params} allowCreateWhileLoading /> :
              <Select id={id} {...params} />)
          }
        </NoSsr>
      </div>
    );
  }
}

IntegrationReactSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  loadOptions: PropTypes.func,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  allowCreate: PropTypes.bool,
  label: PropTypes.string,
  helperText: PropTypes.string,
};

export default withStyles(styles)(IntegrationReactSelect);


// WEBPACK FOOTER //
// ./src/components/Common/MultiAutoComplete/index.js